import React from "react";
import { useNavigate } from "react-router-dom";
import newImage from "../../assets/new-image.png";
import Shape from "../Shape/Shape";
import shape1 from "../../assets/shape1.svg";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";
import "./NewSection.css";

const NewSection = () => {
  const navigate = useNavigate();

  const handleQuoteClick = () => {
    navigate("/contact");
  };

  return (
    <section className="new-section">
      <div className="new-content">
        <h1>
          We Are Candy <br /> Manufacturers
        </h1>
        <h2>Your Trusted Partner in Custom Toy Candies</h2>
        <button className="quote-button" onClick={handleQuoteClick}>
          Get a Quote
        </button>
        <Shape svgPath={shape1} color="#FF6347" className="new-shape1" />
        <Shape svgPath={shape2} color="#FFD700" className="new-shape2" />
        <Shape svgPath={shape3} color="#8A2BE2" className="new-shape3" />
      </div>
      <div className="new-image-container">
        <div className="left-semicircle"></div>
        <img src={newImage} alt="Candy Image" className="new-image" />
        <div className="right-semicircle"></div>
      </div>
    </section>
  );
};

export default NewSection;
